import { request } from '@blade/common';
/**
*@Description: 分页查询设备列表
*/
export const getDevicesList = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/dahua/device/list',
    method: 'POST',
    data,
});
/**
*@Description: 删除设备
*/
export const deleteDevices = (deviceId) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/delete/' + deviceId,
    method: 'DELETE',
});
/**
*@Description: 设备批量删除
*/
export const devicesBatchDelete = (deviceId) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/batch/delete',
    method: 'DELETE',
    data: deviceId
});
// 获取设备详情
export const getDetails = (deviceId) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/detail/' + deviceId,
    method: 'GET',
});
// 编辑设备详情
export const editDetails = (params) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/edit',
    method: 'POST',
    data: params
});
// 新增设备详情
export const addDetails = (params) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/add',
    method: 'POST',
    data: params
});
// 新增设备详情的待选项 - 设备组待选项
export const getGroupNameAry = (params) => request({
    url: '/api/iot-device-management/api/v1/device-groups/devices/tree',
    method: 'POST',
    data: params
});
// table收藏
export const addLike = (deviceId) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/addLike/' + deviceId,
    method: 'POST',
    data: {}
});
// table 取消收藏
export const cancelLike = (deviceId) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/cancelLike/' + deviceId,
    method: 'POST',
    data: {}
});
// 左侧树相关
// 获取整个树结果
export const getTreeData = (params) => request({
    url: '/api/iot-device-management/api/v1/device-groups/tree',
    method: 'POST',
    data: params
});
// 获取当前节点数据
export const getTreeNode = (treeId) => request({
    url: '/api/iot-device-management/api/v1/device-groups/detail/' + treeId,
    method: 'GET'
});
// 新增节点数据
export const addTreeNode = (params) => request({
    url: '/api/iot-device-management/api/v1/device-groups/add',
    method: 'POST',
    data: params
});
// 编辑节点数据
export const editTreeNode = (treeId, params) => request({
    url: '/api/iot-device-management/api/v1/device-groups/modify/' + treeId,
    method: 'PUT',
    data: params
});
// 删除当前节点数据
export const delTreeNode = (treeId) => request({
    url: '/api/iot-device-management/api/v1/device-groups/delete/' + treeId,
    method: 'DELETE'
});
// 获取table上方数据
export const getDevicesSummary = () => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/query/device/summary',
    method: 'GET'
});
export const itsExport = (params) => request({
    url: '/api/iot-device-management/api/v1/its/export',
    method: 'POST',
    data: params
});
export const byExportGroup = (params) => request({
    url: '/api/iot-device-management/api/v1/its/exportByGroup',
    method: 'POST',
    data: params
});
